import clsx from 'clsx';
import React from 'react';
import { ReactComponent as AccountBase } from './accountIcon.svg';
import { ReactComponent as ArrowLeft } from './arrowLeftIcon.svg';
import { ReactComponent as ArrowRight } from './arrowRightIcon.svg';
import { ReactComponent as Lock } from './lockOutlineIcon.svg';
import { ReactComponent as Logo } from './logoIcon.svg';
import { ReactComponent as LogoText } from './logoTextIcon.svg';

// Brand icons use fill="currentColor"; this wrapper injects the central
// `.brand-icon` colour (driven by @primary-color) on every render.
const withBrandColor = (Icon) => {
  const BrandIcon = (props) => (
    <Icon {...props} className={clsx('brand-icon', props?.className)} />
  );
  return BrandIcon;
};

const Account = withBrandColor(AccountBase);

export { ArrowLeft, ArrowRight, LogoText, Logo, Account, Lock };
